import * as Yup from 'yup'

const commonInfoSchema = () => {
  return Yup.object({})
}

export default commonInfoSchema
